export { default as Footer } from "./page";
